import http from "@/settings/apiSettings"

class CrmNomenclatoareDataService{
  save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_Industrii", data);
      }
  
}
export default new CrmNomenclatoareDataService();